import { AnimatePresence, motion } from "motion/react";

import { useSearch } from "@skilitics/designer-ui-components";
import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import { Breadcrumbs } from "../../breadcrumbs";
import { Interactions } from "../../interactions";
import { useLandingPageSettings } from "../../LandingPageSettingsContext";
import { EmptyView } from "./empty-view";
import { GridView } from "./grid-view";
import { LandingPageFooter } from "./LandingPageFooter";
import { ListView } from "./list-view";
import { LoadingView } from "./loading-view";

export const ModulesHeaderView = () => (
  <>
    <Interactions />
    <Breadcrumbs />
  </>
);

const GridViewAnimated = motion.create(GridView);
const ListViewAnimated = motion.create(ListView);

export const ModulesView = () => {
  const { view } = useLandingPageSettings();
  const { results, filteredData, status } = useSearch<InteractModuleListItem>();

  const modules = results ?? filteredData;

  if (status !== "ready") {
    return <LoadingView />;
  }

  if (modules.length === 0) {
    return <EmptyView />;
  }

  return (
    <AnimatePresence mode="wait">
      {view === "grid" ? (
        <GridViewAnimated
          key="grid"
          modules={modules}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        />
      ) : (
        <ListViewAnimated
          key="list"
          modules={modules}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        />
      )}
    </AnimatePresence>
  );
};
